<template>
  <div id="hyhfmb">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'hyhfmb'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/feetemplate/HyhfMb.vue